export const CONSTANTS = {
  features: [
    {
      text: "Ultra-reliable Dedicated Internet Access (DIA) with guaranteed SLAs.",
    },
    {
      text: "Multi-cloud and data center interconnectivity for seamless workload mobility.",
    },
    {
      text: "Comprehensive network monitoring and proactive support for optimal uptime.",
    },
  ],
  title: "Why choose OneMind for internet and DCI services?",
  description: [
    "OneMind Services delivers enterprise-grade Internet and Data Center Interconnect solutions through its platforms. With a cloud-first approach, our solutions offer:",
  ],
  extraContent:
    "Our carrier-neutral approach ensures businesses can choose the best connectivity partners for their specific requirements, without vendor lock-in.",
};
